import React, {useEffect, useState} from "react";
import ShopHeader from "../components/Header";
import ShopFooter from "../components/Footer";

// SHOP DESIGN THEME IMPORTS FOR CSS
// import "./../assets/css/agriox.css";
// import "./../assets/vendors/animate/animate.min.css";
// import "./../assets/vendors/owl-carousel/owl.carousel.min.css";
// import "./../assets/vendors/owl-carousel/owl.theme.default.min.css";
// import "./../assets/vendors/odometer/odometer.min.css";
// import "./../assets/vendors/jquery-magnific-popup/jquery.magnific-popup.css";
// import "./../assets/vendors/nouislider/nouislider.min.css";
// import "./../assets/vendors/nouislider/nouislider.pips.css";
// import "./../assets/vendors/jarallax/jarallax.css";
// import "./../assets/vendors/tiny-slider/tiny-slider.min.css";
// import "./../assets/vendors/twentytwenty/twentytwenty.css";
// import "./../assets/vendors/icomoon-icons/style.css";
// import "./../assets/vendors/toolbar/css/toolbar.css";
// import "./../index.css";

const cssFiles = [
  "/assets/css/agriox.css",
  "/assets/vendors/animate/animate.min.css",
  "/assets/vendors/owl-carousel/owl.carousel.min.css",
  "/assets/vendors/owl-carousel/owl.theme.default.min.css",
  "/assets/vendors/odometer/odometer.min.css",
  "/assets/vendors/jquery-magnific-popup/jquery.magnific-popup.css",
  "/assets/vendors/nouislider/nouislider.min.css",
  "/assets/vendors/nouislider/nouislider.pips.css",
  "/assets/vendors/jarallax/jarallax.css",
  "/assets/vendors/tiny-slider/tiny-slider.min.css",
  "/assets/vendors/twentytwenty/twentytwenty.css",
  "/assets/vendors/icomoon-icons/style.css",
  "/assets/vendors/toolbar/css/toolbar.css",
  "/index.css",
];

function OldThemeLayout({ children }) {
  const [cssLoaded, setCssLoaded] = useState(false);

  useEffect(() => {
    let loadedCount = 0;
    const links = cssFiles.map((href) => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      link.dataset.theme = "oldtheme"; // optional identifier

      link.onload = () => {
        loadedCount++;
        if (loadedCount === cssFiles.length) {
          setCssLoaded(true);
        }
      };

      document.head.appendChild(link);
      return link;
    });

    // Cleanup on unmount
    return () => {
      links.forEach((link) => link.remove());
    };
  }, []);

  if (!cssLoaded) {
    return <div style={{ visibility: "hidden" }}>Loading...</div>; // or a loader
  }
  return (
    <>
      <ShopHeader />
      <main>{children}</main>
      <ShopFooter />
    </>
  );
}

export default OldThemeLayout;
